'use strict';

var cov_123736e3xv = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\dashboard\\dashboardCtrl.js',
      hash = '7af22a31960ff541a305ff5da57b83966c07ee13',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\dashboard\\dashboardCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 274,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 27
        }
      },
      '2': {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 3,
          column: 25
        }
      },
      '3': {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 4,
          column: 45
        }
      },
      '4': {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 22,
          column: 4
        }
      },
      '5': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 8,
          column: 5
        }
      },
      '6': {
        start: {
          line: 7,
          column: 6
        },
        end: {
          line: 7,
          column: 21
        }
      },
      '7': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 11,
          column: 5
        }
      },
      '8': {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 10,
          column: 21
        }
      },
      '9': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 14,
          column: 5
        }
      },
      '10': {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 22
        }
      },
      '11': {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 17,
          column: 5
        }
      },
      '12': {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 22
        }
      },
      '13': {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 20,
          column: 5
        }
      },
      '14': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 22
        }
      },
      '15': {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 19
        }
      },
      '16': {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 32,
          column: 4
        }
      },
      '17': {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 29
        }
      },
      '18': {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 44
        }
      },
      '19': {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 72
        }
      },
      '20': {
        start: {
          line: 34,
          column: 18
        },
        end: {
          line: 34,
          column: 48
        }
      },
      '21': {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 35,
          column: 112
        }
      },
      '22': {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 213,
          column: 4
        }
      },
      '23': {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 40
        }
      },
      '24': {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 76,
          column: 9
        }
      },
      '25': {
        start: {
          line: 43,
          column: 21
        },
        end: {
          line: 43,
          column: 28
        }
      },
      '26': {
        start: {
          line: 44,
          column: 26
        },
        end: {
          line: 44,
          column: 33
        }
      },
      '27': {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 47,
          column: 9
        }
      },
      '28': {
        start: {
          line: 46,
          column: 10
        },
        end: {
          line: 46,
          column: 17
        }
      },
      '29': {
        start: {
          line: 48,
          column: 23
        },
        end: {
          line: 48,
          column: 25
        }
      },
      '30': {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 57,
          column: 9
        }
      },
      '31': {
        start: {
          line: 50,
          column: 10
        },
        end: {
          line: 56,
          column: 11
        }
      },
      '32': {
        start: {
          line: 51,
          column: 27
        },
        end: {
          line: 51,
          column: 39
        }
      },
      '33': {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 54,
          column: 13
        }
      },
      '34': {
        start: {
          line: 53,
          column: 14
        },
        end: {
          line: 53,
          column: 23
        }
      },
      '35': {
        start: {
          line: 55,
          column: 12
        },
        end: {
          line: 55,
          column: 30
        }
      },
      '36': {
        start: {
          line: 58,
          column: 26
        },
        end: {
          line: 58,
          column: 28
        }
      },
      '37': {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 73,
          column: 9
        }
      },
      '38': {
        start: {
          line: 60,
          column: 22
        },
        end: {
          line: 60,
          column: 29
        }
      },
      '39': {
        start: {
          line: 61,
          column: 25
        },
        end: {
          line: 67,
          column: 11
        }
      },
      '40': {
        start: {
          line: 68,
          column: 10
        },
        end: {
          line: 71,
          column: 11
        }
      },
      '41': {
        start: {
          line: 70,
          column: 12
        },
        end: {
          line: 70,
          column: 103
        }
      },
      '42': {
        start: {
          line: 72,
          column: 10
        },
        end: {
          line: 72,
          column: 33
        }
      },
      '43': {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 51
        }
      },
      '44': {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 65
        }
      },
      '45': {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 81,
          column: 7
        }
      },
      '46': {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 15
        }
      },
      '47': {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 86,
          column: 7
        }
      },
      '48': {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 33
        }
      },
      '49': {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 33
        }
      },
      '50': {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 89,
          column: 7
        }
      },
      '51': {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 88,
          column: 24
        }
      },
      '52': {
        start: {
          line: 90,
          column: 21
        },
        end: {
          line: 90,
          column: 82
        }
      },
      '53': {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 93,
          column: 7
        }
      },
      '54': {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 44
        }
      },
      '55': {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 100,
          column: 8
        }
      },
      '56': {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 152,
          column: 9
        }
      },
      '57': {
        start: {
          line: 102,
          column: 26
        },
        end: {
          line: 102,
          column: 33
        }
      },
      '58': {
        start: {
          line: 103,
          column: 24
        },
        end: {
          line: 103,
          column: 26
        }
      },
      '59': {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 124,
          column: 9
        }
      },
      '60': {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 123,
          column: 11
        }
      },
      '61': {
        start: {
          line: 106,
          column: 27
        },
        end: {
          line: 106,
          column: 39
        }
      },
      '62': {
        start: {
          line: 107,
          column: 12
        },
        end: {
          line: 109,
          column: 13
        }
      },
      '63': {
        start: {
          line: 108,
          column: 14
        },
        end: {
          line: 108,
          column: 23
        }
      },
      '64': {
        start: {
          line: 110,
          column: 12
        },
        end: {
          line: 122,
          column: 13
        }
      },
      '65': {
        start: {
          line: 111,
          column: 27
        },
        end: {
          line: 111,
          column: 58
        }
      },
      '66': {
        start: {
          line: 112,
          column: 29
        },
        end: {
          line: 112,
          column: 57
        }
      },
      '67': {
        start: {
          line: 113,
          column: 14
        },
        end: {
          line: 116,
          column: 17
        }
      },
      '68': {
        start: {
          line: 118,
          column: 14
        },
        end: {
          line: 121,
          column: 17
        }
      },
      '69': {
        start: {
          line: 125,
          column: 8
        },
        end: {
          line: 125,
          column: 52
        }
      },
      '70': {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 149,
          column: 9
        }
      },
      '71': {
        start: {
          line: 127,
          column: 10
        },
        end: {
          line: 131,
          column: 11
        }
      },
      '72': {
        start: {
          line: 128,
          column: 12
        },
        end: {
          line: 128,
          column: 40
        }
      },
      '73': {
        start: {
          line: 130,
          column: 12
        },
        end: {
          line: 130,
          column: 27
        }
      },
      '74': {
        start: {
          line: 132,
          column: 10
        },
        end: {
          line: 136,
          column: 11
        }
      },
      '75': {
        start: {
          line: 133,
          column: 12
        },
        end: {
          line: 133,
          column: 40
        }
      },
      '76': {
        start: {
          line: 135,
          column: 12
        },
        end: {
          line: 135,
          column: 27
        }
      },
      '77': {
        start: {
          line: 137,
          column: 10
        },
        end: {
          line: 143,
          column: 11
        }
      },
      '78': {
        start: {
          line: 138,
          column: 12
        },
        end: {
          line: 142,
          column: 13
        }
      },
      '79': {
        start: {
          line: 139,
          column: 14
        },
        end: {
          line: 139,
          column: 74
        }
      },
      '80': {
        start: {
          line: 141,
          column: 14
        },
        end: {
          line: 141,
          column: 45
        }
      },
      '81': {
        start: {
          line: 144,
          column: 10
        },
        end: {
          line: 148,
          column: 11
        }
      },
      '82': {
        start: {
          line: 145,
          column: 12
        },
        end: {
          line: 145,
          column: 26
        }
      },
      '83': {
        start: {
          line: 147,
          column: 12
        },
        end: {
          line: 147,
          column: 110
        }
      },
      '84': {
        start: {
          line: 150,
          column: 8
        },
        end: {
          line: 150,
          column: 52
        }
      },
      '85': {
        start: {
          line: 151,
          column: 8
        },
        end: {
          line: 151,
          column: 47
        }
      },
      '86': {
        start: {
          line: 155,
          column: 20
        },
        end: {
          line: 155,
          column: 43
        }
      },
      '87': {
        start: {
          line: 156,
          column: 26
        },
        end: {
          line: 156,
          column: 67
        }
      },
      '88': {
        start: {
          line: 157,
          column: 24
        },
        end: {
          line: 157,
          column: 65
        }
      },
      '89': {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 179,
          column: 8
        }
      },
      '90': {
        start: {
          line: 180,
          column: 17
        },
        end: {
          line: 180,
          column: 19
        }
      },
      '91': {
        start: {
          line: 181,
          column: 21
        },
        end: {
          line: 181,
          column: 41
        }
      },
      '92': {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 197,
          column: 7
        }
      },
      '93': {
        start: {
          line: 183,
          column: 8
        },
        end: {
          line: 189,
          column: 9
        }
      },
      '94': {
        start: {
          line: 184,
          column: 10
        },
        end: {
          line: 186,
          column: 11
        }
      },
      '95': {
        start: {
          line: 185,
          column: 12
        },
        end: {
          line: 185,
          column: 21
        }
      },
      '96': {
        start: {
          line: 187,
          column: 10
        },
        end: {
          line: 187,
          column: 35
        }
      },
      '97': {
        start: {
          line: 188,
          column: 10
        },
        end: {
          line: 188,
          column: 16
        }
      },
      '98': {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 196,
          column: 9
        }
      },
      '99': {
        start: {
          line: 193,
          column: 20
        },
        end: {
          line: 193,
          column: 82
        }
      },
      '100': {
        start: {
          line: 195,
          column: 10
        },
        end: {
          line: 195,
          column: 48
        }
      },
      '101': {
        start: {
          line: 198,
          column: 6
        },
        end: {
          line: 200,
          column: 7
        }
      },
      '102': {
        start: {
          line: 199,
          column: 8
        },
        end: {
          line: 199,
          column: 15
        }
      },
      '103': {
        start: {
          line: 202,
          column: 6
        },
        end: {
          line: 204,
          column: 7
        }
      },
      '104': {
        start: {
          line: 203,
          column: 8
        },
        end: {
          line: 203,
          column: 46
        }
      },
      '105': {
        start: {
          line: 206,
          column: 6
        },
        end: {
          line: 210,
          column: 7
        }
      },
      '106': {
        start: {
          line: 207,
          column: 8
        },
        end: {
          line: 207,
          column: 104
        }
      },
      '107': {
        start: {
          line: 208,
          column: 8
        },
        end: {
          line: 208,
          column: 48
        }
      },
      '108': {
        start: {
          line: 209,
          column: 8
        },
        end: {
          line: 209,
          column: 50
        }
      },
      '109': {
        start: {
          line: 215,
          column: 2
        },
        end: {
          line: 232,
          column: 4
        }
      },
      '110': {
        start: {
          line: 217,
          column: 4
        },
        end: {
          line: 217,
          column: 46
        }
      },
      '111': {
        start: {
          line: 218,
          column: 4
        },
        end: {
          line: 218,
          column: 46
        }
      },
      '112': {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 219,
          column: 36
        }
      },
      '113': {
        start: {
          line: 220,
          column: 4
        },
        end: {
          line: 220,
          column: 25
        }
      },
      '114': {
        start: {
          line: 221,
          column: 4
        },
        end: {
          line: 231,
          column: 7
        }
      },
      '115': {
        start: {
          line: 222,
          column: 6
        },
        end: {
          line: 230,
          column: 7
        }
      },
      '116': {
        start: {
          line: 223,
          column: 8
        },
        end: {
          line: 226,
          column: 9
        }
      },
      '117': {
        start: {
          line: 224,
          column: 25
        },
        end: {
          line: 224,
          column: 46
        }
      },
      '118': {
        start: {
          line: 225,
          column: 10
        },
        end: {
          line: 225,
          column: 44
        }
      },
      '119': {
        start: {
          line: 227,
          column: 8
        },
        end: {
          line: 227,
          column: 98
        }
      },
      '120': {
        start: {
          line: 228,
          column: 8
        },
        end: {
          line: 228,
          column: 64
        }
      },
      '121': {
        start: {
          line: 229,
          column: 8
        },
        end: {
          line: 229,
          column: 64
        }
      },
      '122': {
        start: {
          line: 234,
          column: 2
        },
        end: {
          line: 264,
          column: 4
        }
      },
      '123': {
        start: {
          line: 235,
          column: 4
        },
        end: {
          line: 263,
          column: 7
        }
      },
      '124': {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 236,
          column: 35
        }
      },
      '125': {
        start: {
          line: 237,
          column: 6
        },
        end: {
          line: 262,
          column: 7
        }
      },
      '126': {
        start: {
          line: 238,
          column: 18
        },
        end: {
          line: 238,
          column: 20
        }
      },
      '127': {
        start: {
          line: 239,
          column: 8
        },
        end: {
          line: 244,
          column: 9
        }
      },
      '128': {
        start: {
          line: 240,
          column: 10
        },
        end: {
          line: 243,
          column: 11
        }
      },
      '129': {
        start: {
          line: 241,
          column: 12
        },
        end: {
          line: 241,
          column: 47
        }
      },
      '130': {
        start: {
          line: 242,
          column: 12
        },
        end: {
          line: 242,
          column: 18
        }
      },
      '131': {
        start: {
          line: 245,
          column: 8
        },
        end: {
          line: 247,
          column: 9
        }
      },
      '132': {
        start: {
          line: 246,
          column: 10
        },
        end: {
          line: 246,
          column: 19
        }
      },
      '133': {
        start: {
          line: 248,
          column: 8
        },
        end: {
          line: 254,
          column: 11
        }
      },
      '134': {
        start: {
          line: 255,
          column: 8
        },
        end: {
          line: 261,
          column: 11
        }
      },
      '135': {
        start: {
          line: 266,
          column: 2
        },
        end: {
          line: 270,
          column: 4
        }
      },
      '136': {
        start: {
          line: 267,
          column: 4
        },
        end: {
          line: 269,
          column: 7
        }
      },
      '137': {
        start: {
          line: 268,
          column: 6
        },
        end: {
          line: 268,
          column: 33
        }
      },
      '138': {
        start: {
          line: 271,
          column: 2
        },
        end: {
          line: 271,
          column: 53
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 50
          },
          end: {
            line: 1,
            column: 51
          }
        },
        loc: {
          start: {
            line: 1,
            column: 159
          },
          end: {
            line: 274,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 30
          },
          end: {
            line: 5,
            column: 31
          }
        },
        loc: {
          start: {
            line: 5,
            column: 46
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 5
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 42,
            column: 77
          },
          end: {
            line: 42,
            column: 78
          }
        },
        loc: {
          start: {
            line: 42,
            column: 86
          },
          end: {
            line: 76,
            column: 7
          }
        },
        line: 42
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 101,
            column: 51
          },
          end: {
            line: 101,
            column: 52
          }
        },
        loc: {
          start: {
            line: 101,
            column: 59
          },
          end: {
            line: 152,
            column: 7
          }
        },
        line: 101
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 215,
            column: 29
          },
          end: {
            line: 215,
            column: 30
          }
        },
        loc: {
          start: {
            line: 215,
            column: 41
          },
          end: {
            line: 232,
            column: 3
          }
        },
        line: 215
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 221,
            column: 60
          },
          end: {
            line: 221,
            column: 61
          }
        },
        loc: {
          start: {
            line: 221,
            column: 68
          },
          end: {
            line: 231,
            column: 5
          }
        },
        line: 221
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 234,
            column: 29
          },
          end: {
            line: 234,
            column: 30
          }
        },
        loc: {
          start: {
            line: 234,
            column: 41
          },
          end: {
            line: 264,
            column: 3
          }
        },
        line: 234
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 235,
            column: 56
          },
          end: {
            line: 235,
            column: 57
          }
        },
        loc: {
          start: {
            line: 235,
            column: 64
          },
          end: {
            line: 263,
            column: 5
          }
        },
        line: 235
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 266,
            column: 18
          },
          end: {
            line: 266,
            column: 19
          }
        },
        loc: {
          start: {
            line: 266,
            column: 30
          },
          end: {
            line: 270,
            column: 3
          }
        },
        line: 266
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 267,
            column: 51
          },
          end: {
            line: 267,
            column: 52
          }
        },
        loc: {
          start: {
            line: 267,
            column: 59
          },
          end: {
            line: 269,
            column: 5
          }
        },
        line: 267
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 6,
            column: 4
          },
          end: {
            line: 8,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 6,
            column: 4
          },
          end: {
            line: 8,
            column: 5
          }
        }, {
          start: {
            line: 6,
            column: 4
          },
          end: {
            line: 8,
            column: 5
          }
        }],
        line: 6
      },
      '1': {
        loc: {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        }, {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        }],
        line: 9
      },
      '2': {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        }],
        line: 12
      },
      '3': {
        loc: {
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        }, {
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        }],
        line: 15
      },
      '4': {
        loc: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        }, {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 20,
            column: 5
          }
        }],
        line: 18
      },
      '5': {
        loc: {
          start: {
            line: 37,
            column: 16
          },
          end: {
            line: 37,
            column: 128
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 37,
            column: 16
          },
          end: {
            line: 37,
            column: 106
          }
        }, {
          start: {
            line: 37,
            column: 110
          },
          end: {
            line: 37,
            column: 128
          }
        }],
        line: 37
      },
      '6': {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        }],
        line: 45
      },
      '7': {
        loc: {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        }, {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        }],
        line: 49
      },
      '8': {
        loc: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 54,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 54,
            column: 13
          }
        }, {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 54,
            column: 13
          }
        }],
        line: 52
      },
      '9': {
        loc: {
          start: {
            line: 52,
            column: 16
          },
          end: {
            line: 52,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 52,
            column: 16
          },
          end: {
            line: 52,
            column: 36
          }
        }, {
          start: {
            line: 52,
            column: 40
          },
          end: {
            line: 52,
            column: 47
          }
        }],
        line: 52
      },
      '10': {
        loc: {
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 43
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 38
          }
        }, {
          start: {
            line: 64,
            column: 42
          },
          end: {
            line: 64,
            column: 43
          }
        }],
        line: 64
      },
      '11': {
        loc: {
          start: {
            line: 65,
            column: 16
          },
          end: {
            line: 65,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 65,
            column: 16
          },
          end: {
            line: 65,
            column: 36
          }
        }, {
          start: {
            line: 65,
            column: 40
          },
          end: {
            line: 65,
            column: 41
          }
        }],
        line: 65
      },
      '12': {
        loc: {
          start: {
            line: 70,
            column: 44
          },
          end: {
            line: 70,
            column: 100
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 70,
            column: 67
          },
          end: {
            line: 70,
            column: 77
          }
        }, {
          start: {
            line: 70,
            column: 80
          },
          end: {
            line: 70,
            column: 100
          }
        }],
        line: 70
      },
      '13': {
        loc: {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }, {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }],
        line: 79
      },
      '14': {
        loc: {
          start: {
            line: 79,
            column: 10
          },
          end: {
            line: 79,
            column: 37
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 79,
            column: 10
          },
          end: {
            line: 79,
            column: 15
          }
        }, {
          start: {
            line: 79,
            column: 19
          },
          end: {
            line: 79,
            column: 37
          }
        }],
        line: 79
      },
      '15': {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 86,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 86,
            column: 7
          }
        }, {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 86,
            column: 7
          }
        }],
        line: 82
      },
      '16': {
        loc: {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        }, {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 89,
            column: 7
          }
        }],
        line: 87
      },
      '17': {
        loc: {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        }, {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        }],
        line: 91
      },
      '18': {
        loc: {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 124,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 124,
            column: 9
          }
        }, {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 124,
            column: 9
          }
        }],
        line: 104
      },
      '19': {
        loc: {
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 109,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 109,
            column: 13
          }
        }, {
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 109,
            column: 13
          }
        }],
        line: 107
      },
      '20': {
        loc: {
          start: {
            line: 107,
            column: 16
          },
          end: {
            line: 107,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 107,
            column: 16
          },
          end: {
            line: 107,
            column: 36
          }
        }, {
          start: {
            line: 107,
            column: 40
          },
          end: {
            line: 107,
            column: 47
          }
        }],
        line: 107
      },
      '21': {
        loc: {
          start: {
            line: 110,
            column: 12
          },
          end: {
            line: 122,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 110,
            column: 12
          },
          end: {
            line: 122,
            column: 13
          }
        }, {
          start: {
            line: 110,
            column: 12
          },
          end: {
            line: 122,
            column: 13
          }
        }],
        line: 110
      },
      '22': {
        loc: {
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 148,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 148,
            column: 11
          }
        }, {
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 148,
            column: 11
          }
        }],
        line: 144
      },
      '23': {
        loc: {
          start: {
            line: 144,
            column: 14
          },
          end: {
            line: 144,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 144,
            column: 14
          },
          end: {
            line: 144,
            column: 28
          }
        }, {
          start: {
            line: 144,
            column: 32
          },
          end: {
            line: 144,
            column: 47
          }
        }],
        line: 144
      },
      '24': {
        loc: {
          start: {
            line: 147,
            column: 43
          },
          end: {
            line: 147,
            column: 108
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 147,
            column: 81
          },
          end: {
            line: 147,
            column: 82
          }
        }, {
          start: {
            line: 147,
            column: 86
          },
          end: {
            line: 147,
            column: 107
          }
        }],
        line: 147
      },
      '25': {
        loc: {
          start: {
            line: 147,
            column: 44
          },
          end: {
            line: 147,
            column: 77
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 147,
            column: 44
          },
          end: {
            line: 147,
            column: 58
          }
        }, {
          start: {
            line: 147,
            column: 62
          },
          end: {
            line: 147,
            column: 77
          }
        }],
        line: 147
      },
      '26': {
        loc: {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 197,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 197,
            column: 7
          }
        }, {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 197,
            column: 7
          }
        }],
        line: 182
      },
      '27': {
        loc: {
          start: {
            line: 184,
            column: 10
          },
          end: {
            line: 186,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 184,
            column: 10
          },
          end: {
            line: 186,
            column: 11
          }
        }, {
          start: {
            line: 184,
            column: 10
          },
          end: {
            line: 186,
            column: 11
          }
        }],
        line: 184
      },
      '28': {
        loc: {
          start: {
            line: 195,
            column: 27
          },
          end: {
            line: 195,
            column: 47
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 195,
            column: 31
          },
          end: {
            line: 195,
            column: 34
          }
        }, {
          start: {
            line: 195,
            column: 37
          },
          end: {
            line: 195,
            column: 47
          }
        }],
        line: 195
      },
      '29': {
        loc: {
          start: {
            line: 198,
            column: 6
          },
          end: {
            line: 200,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 198,
            column: 6
          },
          end: {
            line: 200,
            column: 7
          }
        }, {
          start: {
            line: 198,
            column: 6
          },
          end: {
            line: 200,
            column: 7
          }
        }],
        line: 198
      },
      '30': {
        loc: {
          start: {
            line: 207,
            column: 37
          },
          end: {
            line: 207,
            column: 102
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 207,
            column: 55
          },
          end: {
            line: 207,
            column: 69
          }
        }, {
          start: {
            line: 207,
            column: 72
          },
          end: {
            line: 207,
            column: 102
          }
        }],
        line: 207
      },
      '31': {
        loc: {
          start: {
            line: 223,
            column: 8
          },
          end: {
            line: 226,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 223,
            column: 8
          },
          end: {
            line: 226,
            column: 9
          }
        }, {
          start: {
            line: 223,
            column: 8
          },
          end: {
            line: 226,
            column: 9
          }
        }],
        line: 223
      },
      '32': {
        loc: {
          start: {
            line: 225,
            column: 28
          },
          end: {
            line: 225,
            column: 43
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 225,
            column: 28
          },
          end: {
            line: 225,
            column: 37
          }
        }, {
          start: {
            line: 225,
            column: 41
          },
          end: {
            line: 225,
            column: 43
          }
        }],
        line: 225
      },
      '33': {
        loc: {
          start: {
            line: 240,
            column: 10
          },
          end: {
            line: 243,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 240,
            column: 10
          },
          end: {
            line: 243,
            column: 11
          }
        }, {
          start: {
            line: 240,
            column: 10
          },
          end: {
            line: 243,
            column: 11
          }
        }],
        line: 240
      },
      '34': {
        loc: {
          start: {
            line: 245,
            column: 8
          },
          end: {
            line: 247,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 245,
            column: 8
          },
          end: {
            line: 247,
            column: 9
          }
        }, {
          start: {
            line: 245,
            column: 8
          },
          end: {
            line: 247,
            column: 9
          }
        }],
        line: 245
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_123736e3xv.s[0]++;
angular.module('app').controller('dashboardCtrl', function ($scope, $translate, $otherHttpService, $deltadate, $location, $rootScope, $filter, $deltaTypeIndicateur) {
  cov_123736e3xv.f[0]++;
  cov_123736e3xv.s[1]++;

  $scope.listProjects = [];
  cov_123736e3xv.s[2]++;
  $scope.PATH = 'Projet';
  cov_123736e3xv.s[3]++;
  $deltaTypeIndicateur.addController($scope);
  cov_123736e3xv.s[4]++;
  $scope.getIndicateurLabel = function (item) {
    cov_123736e3xv.f[1]++;
    cov_123736e3xv.s[5]++;

    if (!item.lie) {
      cov_123736e3xv.b[0][0]++;
      cov_123736e3xv.s[6]++;

      return item.li;
    } else {
      cov_123736e3xv.b[0][1]++;
    }
    cov_123736e3xv.s[7]++;
    if (item.lie.trim() == '') {
      cov_123736e3xv.b[1][0]++;
      cov_123736e3xv.s[8]++;

      return item.li;
    } else {
      cov_123736e3xv.b[1][1]++;
    }
    cov_123736e3xv.s[9]++;
    if (!item.li) {
      cov_123736e3xv.b[2][0]++;
      cov_123736e3xv.s[10]++;

      return item.lie;
    } else {
      cov_123736e3xv.b[2][1]++;
    }
    cov_123736e3xv.s[11]++;
    if (item.li.trim() == '') {
      cov_123736e3xv.b[3][0]++;
      cov_123736e3xv.s[12]++;

      return item.lie;
    } else {
      cov_123736e3xv.b[3][1]++;
    }
    cov_123736e3xv.s[13]++;
    if ($rootScope.language.id == 'en') {
      cov_123736e3xv.b[4][0]++;
      cov_123736e3xv.s[14]++;

      return item.lie;
    } else {
      cov_123736e3xv.b[4][1]++;
    }
    cov_123736e3xv.s[15]++;
    return item.li;
  };
  cov_123736e3xv.s[16]++;
  $scope.personalize = {
    editlabel: false,
    labelPerso: $rootScope.currentProject.project.getLabelTB(),
    editlabelPerso: $rootScope.currentProject.project.getLabelTB(),
    save: function save() {
      cov_123736e3xv.s[17]++;

      this.editlabel = false;
      cov_123736e3xv.s[18]++;
      this.labelPerso = this.editlabelPerso;
      cov_123736e3xv.s[19]++;
      $rootScope.currentProject.project.setLabelTB(this.editlabelPerso);
    }
  };
  /** ********************************************************************************* */
  var project = (cov_123736e3xv.s[20]++, $rootScope.getCurrentProject());
  cov_123736e3xv.s[21]++;
  $scope.YearList = $deltadate.getYearBetween(project.project.DATE_DEB_PROJET, project.project.DATE_FIN_PROJET);
  cov_123736e3xv.s[22]++;
  $scope.indicateurDashbord = {
    yearSelect: (cov_123736e3xv.b[5][0]++, $filter('filter')($scope.YearList, { id: Date.newDate().getFullYear().toString() }, true)[0]) || (cov_123736e3xv.b[5][1]++, $scope.YearList[0]),
    period: 1,
    data: [],
    getSituationIndicateur: function getSituationIndicateur() {
      cov_123736e3xv.s[23]++;

      $scope.dateIndic = Date.newDate();
      cov_123736e3xv.s[24]++;
      $otherHttpService.get('Indicateurs', { get: 'tbhome', idl: 0, type: 0 }, function (dataR) {
        cov_123736e3xv.f[2]++;

        var data = (cov_123736e3xv.s[25]++, dataR.d);
        var firstData = (cov_123736e3xv.s[26]++, data[0]);
        cov_123736e3xv.s[27]++;
        if (!firstData) {
          cov_123736e3xv.b[6][0]++;
          cov_123736e3xv.s[28]++;

          return;
        } else {
          cov_123736e3xv.b[6][1]++;
        }
        var header = (cov_123736e3xv.s[29]++, []);
        cov_123736e3xv.s[30]++;
        if (firstData) {
          cov_123736e3xv.b[7][0]++;
          cov_123736e3xv.s[31]++;

          for (var prop in firstData) {
            var proprN = (cov_123736e3xv.s[32]++, Number(prop));
            cov_123736e3xv.s[33]++;
            if ((cov_123736e3xv.b[9][0]++, proprN == Number.NaN) || (cov_123736e3xv.b[9][1]++, !proprN)) {
              cov_123736e3xv.b[8][0]++;
              cov_123736e3xv.s[34]++;

              continue;
            } else {
              cov_123736e3xv.b[8][1]++;
            }
            cov_123736e3xv.s[35]++;
            header.push(prop);
          }
        } else {
          cov_123736e3xv.b[7][1]++;
        }
        var dataFinal = (cov_123736e3xv.s[36]++, []);
        cov_123736e3xv.s[37]++;
        for (var i = 0; i < data.length; i++) {
          var obj = (cov_123736e3xv.s[38]++, data[i]);
          var secobj = (cov_123736e3xv.s[39]++, {
            lib: $scope.getIndicateurLabel(obj),
            des: obj.ll, c: obj.ci, t: obj.ti,
            vc: (cov_123736e3xv.b[10][0]++, eval(obj.VALEUR_CIBLE)) || (cov_123736e3xv.b[10][1]++, 0),
            vr: (cov_123736e3xv.b[11][0]++, eval(obj.VALEUR_REF)) || (cov_123736e3xv.b[11][1]++, 0),
            d1: [], d2: [], d: [], id: obj.id, idcl: obj.idcl, p: obj.p
          });
          cov_123736e3xv.s[40]++;
          for (var j = 0; j < header.length; j++) {
            cov_123736e3xv.s[41]++;

            // secobj.d.push({y:header[j],v:eval(obj[header[j]])});
            secobj.d.push({ y: header[j], v: obj[header[j]] == '' ? (cov_123736e3xv.b[12][0]++, Number.NaN) : (cov_123736e3xv.b[12][1]++, eval(obj[header[j]])) });
          }
          cov_123736e3xv.s[42]++;
          dataFinal.push(secobj);
        }
        cov_123736e3xv.s[43]++;
        $scope.indicateurDashbord.data = dataFinal;
        cov_123736e3xv.s[44]++;
        $scope.indicateurDashbord.selectIndicateur(dataFinal[0]);
      });
    },
    selectIndicateur: function selectIndicateur(item) {
      cov_123736e3xv.s[45]++;

      if ((cov_123736e3xv.b[14][0]++, !item) && (cov_123736e3xv.b[14][1]++, !this.selectedItem)) {
        cov_123736e3xv.b[13][0]++;
        cov_123736e3xv.s[46]++;

        return;
      } else {
        cov_123736e3xv.b[13][1]++;
      }
      cov_123736e3xv.s[47]++;
      if (!item) {
        cov_123736e3xv.b[15][0]++;
        cov_123736e3xv.s[48]++;

        item = this.selectedItem;
      } else {
        cov_123736e3xv.b[15][1]++;
        cov_123736e3xv.s[49]++;

        this.selectedItem = item;
      }
      cov_123736e3xv.s[50]++;
      if ($scope.indicateurDashbord.selectedItem.p == 1) {
        cov_123736e3xv.b[16][0]++;
        cov_123736e3xv.s[51]++;

        this.period = 2;
      } else {
        cov_123736e3xv.b[16][1]++;
      }
      var params = (cov_123736e3xv.s[52]++, { get: 'tbhome_detail', id: item.id, idcl: item.idcl, type: 0 });
      cov_123736e3xv.s[53]++;
      if (this.period == 2) {
        cov_123736e3xv.b[17][0]++;
        cov_123736e3xv.s[54]++;

        params.get = 'tbhome_detail_period';
      } else {
        cov_123736e3xv.b[17][1]++;
      }
      cov_123736e3xv.s[55]++;
      this.grapheDash = {
        labels: [],
        series: [],
        data: [],
        options: [],
        colors: []
      };
      cov_123736e3xv.s[56]++;
      $otherHttpService.get('Indicateurs', params, function (data) {
        cov_123736e3xv.f[3]++;

        var firstData = (cov_123736e3xv.s[57]++, data[0]);
        var headers = (cov_123736e3xv.s[58]++, []);
        cov_123736e3xv.s[59]++;
        if (firstData) {
          cov_123736e3xv.b[18][0]++;
          cov_123736e3xv.s[60]++;

          for (var prop in firstData) {
            var proprN = (cov_123736e3xv.s[61]++, Number(prop));
            cov_123736e3xv.s[62]++;
            if ((cov_123736e3xv.b[20][0]++, proprN == Number.NaN) || (cov_123736e3xv.b[20][1]++, !proprN)) {
              cov_123736e3xv.b[19][0]++;
              cov_123736e3xv.s[63]++;

              continue;
            } else {
              cov_123736e3xv.b[19][1]++;
            }
            cov_123736e3xv.s[64]++;
            if ($scope.indicateurDashbord.period == 2) {
              cov_123736e3xv.b[21][0]++;

              var year = (cov_123736e3xv.s[65]++, prop.toString().substring(0, 4));
              var period = (cov_123736e3xv.s[66]++, prop.toString().substring(4));
              cov_123736e3xv.s[67]++;
              headers.push({
                label: $deltadate.getLabelPerioddepth(period * (12 / eval($scope.indicateurDashbord.selectedItem.p)), 12, true) + ' ' + year,
                index: prop
              });
            } else {
              cov_123736e3xv.b[21][1]++;
              cov_123736e3xv.s[68]++;

              headers.push({
                label: prop,
                index: prop
              });
            }
          }
        } else {
          cov_123736e3xv.b[18][1]++;
        }
        cov_123736e3xv.s[69]++;
        $scope.indicateurDashbord.headers = headers;
        cov_123736e3xv.s[70]++;
        for (var i = 0; i < data.length; i++) {
          cov_123736e3xv.s[71]++;

          try {
            cov_123736e3xv.s[72]++;

            data[i].c = eval(data[i].c);
          } catch (e) {
            cov_123736e3xv.s[73]++;

            data[i].c = '';
          }
          cov_123736e3xv.s[74]++;
          try {
            cov_123736e3xv.s[75]++;

            data[i].T = eval(data[i].T);
          } catch (e) {
            cov_123736e3xv.s[76]++;

            data[i].T = '';
          }
          cov_123736e3xv.s[77]++;
          for (var j = 0; j < headers.length; j++) {
            cov_123736e3xv.s[78]++;

            try {
              cov_123736e3xv.s[79]++;

              data[i][headers[j].index] = eval(data[i][headers[j].index]);
            } catch (e) {
              cov_123736e3xv.s[80]++;

              data[i][headers[j].index] = '';
            }
          }
          cov_123736e3xv.s[81]++;
          if ((cov_123736e3xv.b[23][0]++, data[i].T == 0) || (cov_123736e3xv.b[23][1]++, data[i].T == '')) {
            cov_123736e3xv.b[22][0]++;
            cov_123736e3xv.s[82]++;

            data[i].T = 0;
          } else {
            cov_123736e3xv.b[22][1]++;
            cov_123736e3xv.s[83]++;

            data[i].T = data[i].T = 100 * ((cov_123736e3xv.b[25][0]++, data[i].c == 0) || (cov_123736e3xv.b[25][1]++, data[i].c == '') ? (cov_123736e3xv.b[24][0]++, 0) : (cov_123736e3xv.b[24][1]++, data[i].T / data[i].c));
          }
        }
        cov_123736e3xv.s[84]++;
        $scope.indicateurDashbord.dataDetail = data;
        cov_123736e3xv.s[85]++;
        $scope.indicateurDashbord.drawGraphe();
      });
    },
    drawGraphe: function drawGraphe() {
      var color = (cov_123736e3xv.s[86]++, $rootScope.personalData);
      var valeurCible = (cov_123736e3xv.s[87]++, $scope.indicateurDashbord.selectedItem.vc);
      var valeurRef = (cov_123736e3xv.s[88]++, $scope.indicateurDashbord.selectedItem.vr);
      cov_123736e3xv.s[89]++;
      this.grapheDash = {
        labels: [],
        series: [$translate.instant('INDICATOR.REF'), $translate.instant('INDICATOR.REAL_VAL'), $translate.instant('INDICATOR.TARGET')],
        data: [[], [], []],
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          },
          elements: {
            line: {
              fill: false,
              spanGaps: false,
              tension: 0
            }
          }
        },
        colors: ['rgba(' + color.rframeVR + ',0.7)', 'rgba(' + color.rframeVD + ',0.7)', 'rgba(' + color.rframeVC + ',0.7)']
      };
      var item = (cov_123736e3xv.s[90]++, {});
      var format = (cov_123736e3xv.s[91]++, this.selectedItem.fo);
      cov_123736e3xv.s[92]++;
      if (this.period == 2) {
        cov_123736e3xv.b[26][0]++;
        cov_123736e3xv.s[93]++;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.dataDetail[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var elp = _step.value;
            cov_123736e3xv.s[94]++;

            if (elp.lo) {
              cov_123736e3xv.b[27][0]++;
              cov_123736e3xv.s[95]++;

              continue;
            } else {
              cov_123736e3xv.b[27][1]++;
            }
            cov_123736e3xv.s[96]++;
            item = angular.copy(elp);
            cov_123736e3xv.s[97]++;
            break;
          }
          // item= angular.copy(  $filter("filter")(this.dataDetail , {lo:undefined} , true)[0]);
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        cov_123736e3xv.b[26][1]++;
        cov_123736e3xv.s[98]++;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.headers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var el = _step2.value;

            var v = (cov_123736e3xv.s[99]++, $filter('filter')(this.selectedItem.d, { y: el.index }, true)[0]);
            // item[el.index]=v?v.v:0;
            cov_123736e3xv.s[100]++;
            item[el.index] = v ? (cov_123736e3xv.b[28][0]++, v.v) : (cov_123736e3xv.b[28][1]++, Number.NaN);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      cov_123736e3xv.s[101]++;
      if (!item) {
        cov_123736e3xv.b[29][0]++;
        cov_123736e3xv.s[102]++;

        return;
      } else {
        cov_123736e3xv.b[29][1]++;
      }
      //* ************************************* Label ***************************************/
      cov_123736e3xv.s[103]++;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.headers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _el = _step3.value;
          cov_123736e3xv.s[104]++;

          this.grapheDash.labels.push(_el.label);
        }
        //* *********************************** Data ***************************************/
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      cov_123736e3xv.s[105]++;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.headers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _el2 = _step4.value;
          cov_123736e3xv.s[106]++;

          this.grapheDash.data[1].push(!item[_el2.index] ? (cov_123736e3xv.b[30][0]++, item[_el2.index]) : (cov_123736e3xv.b[30][1]++, item[_el2.index].toFixed(format)));
          cov_123736e3xv.s[107]++;
          this.grapheDash.data[0].push(valeurRef);
          cov_123736e3xv.s[108]++;
          this.grapheDash.data[2].push(valeurCible);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  };
  /** ********************************************************************************** */
  cov_123736e3xv.s[109]++;
  $scope.EvolutionActivite = function () {
    cov_123736e3xv.f[4]++;
    cov_123736e3xv.s[110]++;

    // $rootScope.getPeriodLabel
    $scope.lineDataEvol.datasets[0].data = [];
    cov_123736e3xv.s[111]++;
    $scope.lineDataEvol.datasets[1].data = [];
    cov_123736e3xv.s[112]++;
    $scope.lineDataEvol.labels = [];
    cov_123736e3xv.s[113]++;
    $scope.yearPTBA = '';
    cov_123736e3xv.s[114]++;
    $otherHttpService.get('Activites', { get: 'hometbEvol' }, function (data) {
      cov_123736e3xv.f[5]++;
      cov_123736e3xv.s[115]++;

      for (var j = 0; j < data.length; j++) {
        cov_123736e3xv.s[116]++;

        if (j == 0) {
          cov_123736e3xv.b[31][0]++;

          var tampon = (cov_123736e3xv.s[117]++, data[j].id.split('-'));
          cov_123736e3xv.s[118]++;
          $scope.yearPTBA = (cov_123736e3xv.b[32][0]++, tampon[0]) || (cov_123736e3xv.b[32][1]++, '');
        } else {
          cov_123736e3xv.b[31][1]++;
        }
        cov_123736e3xv.s[119]++;
        $scope.lineDataEvol.labels.push($rootScope.getPeriodLabel(data[j].d) + ' ' + data[j].num);
        cov_123736e3xv.s[120]++;
        $scope.lineDataEvol.datasets[0].data.push(data[j].tf);
        cov_123736e3xv.s[121]++;
        $scope.lineDataEvol.datasets[1].data.push(data[j].tp);
      }
    });
  };

  cov_123736e3xv.s[122]++;
  $scope.RepartionActivite = function () {
    cov_123736e3xv.f[6]++;
    cov_123736e3xv.s[123]++;

    $otherHttpService.get('Activites', { get: 'hometb' }, function (data) {
      cov_123736e3xv.f[7]++;
      cov_123736e3xv.s[124]++;

      $scope.doughnutData_phy = [];
      cov_123736e3xv.s[125]++;
      for (var j = 0; j < data.length; j++) {
        var cls = (cov_123736e3xv.s[126]++, '');
        cov_123736e3xv.s[127]++;
        for (var k = 0; k < $rootScope.ColorsData.length; k++) {
          cov_123736e3xv.s[128]++;

          if ($rootScope.ColorsData[k].id == data[j].idcol) {
            cov_123736e3xv.b[33][0]++;
            cov_123736e3xv.s[129]++;

            cls = $rootScope.ColorsData[k].cls;
            cov_123736e3xv.s[130]++;
            break;
          } else {
            cov_123736e3xv.b[33][1]++;
          }
        }
        cov_123736e3xv.s[131]++;
        if (cls == '') {
          cov_123736e3xv.b[34][0]++;
          cov_123736e3xv.s[132]++;

          continue;
        } else {
          cov_123736e3xv.b[34][1]++;
        }
        cov_123736e3xv.s[133]++;
        $scope.doughnutData_phy.push({
          value: data[j].tp,
          highlight: '#1ab394',
          label: data[j].lib,
          color: cls,
          hoverbackgroundColor: cls
        });
        cov_123736e3xv.s[134]++;
        $scope.doughnutData_fin.push({
          value: data[j].tf,
          highlight: '#1ab394',
          label: data[j].lib,
          color: cls,
          hoverbackgroundColor: cls
        });
      }
    });
  };

  cov_123736e3xv.s[135]++;
  $scope.getAll = function () {
    cov_123736e3xv.f[8]++;
    cov_123736e3xv.s[136]++;

    $CRUDService.getAll($scope.PATH, { get: 'all' }, function (data) {
      cov_123736e3xv.f[9]++;
      cov_123736e3xv.s[137]++;

      $scope.listProjects = data;
    });
  };
  cov_123736e3xv.s[138]++;
  $scope.indicateurDashbord.getSituationIndicateur();
  // $scope.RepartionActivite();
  // $scope.EvolutionActivite();
});